<template>
  <div class="hospital content-continer">
    <div class="base-content menas">
      <p class="title">{{Msg.orgName}}</p>
      <ul>
        <li>
          <span class="sed-title">地区</span>
          {{Msg.province?Msg.province:'无'}}
        </li>
        <li>
          <span class="sed-title">备案邮箱</span>
          {{ Msg.email?Msg.email:'无'}}
        </li>
        <li>
          <span class="sed-title">资格证书</span>
          <img :src="imgurl+Msg.certImg" style="width: 120px;vertical-align:top;" />
        </li>
      </ul>
    </div>
    <div class="base-content menas">
      <p class="title">联系人信息</p>
      <ul>
        <li>
          <span class="sed-title">
            <i class="el-icon-user blue"></i>
          </span>
          {{Msg.contactName}}
        </li>
        <li>
          <span class="sed-title">
            <i class="el-icon-mobile-phone blue"></i>
          </span>
          {{Msg.contactMobile}}
        </li>
      </ul>
      <p class="right edit" style="margin-top:-18px;">
        <el-button type="text" @click="dialogVisible2 = true">
          <i class="el-icon-edit-outline sed-title"></i>编辑
        </el-button>
      </p>
    </div>
    <!-- 修改信息弹框 -->
    <el-dialog title="联系人修改" :visible.sync="dialogVisible2" width="430px" center>
      <form class="forms grid-content">
        <p>
          <span>姓名</span>
          <input type="text" placeholder="输入姓名" v-model="cnName" />
        </p>
        <p>
          <span>电话</span>
          <input type="text" placeholder="输入手机号" v-model="mobile" />
        </p>
      </form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="submit1">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 修改密码 -->
    <div class="base-content menas1">
      <p class="title left" style="margin:0px;">密码修改</p>
      <p class="right edit">
        <el-button type="text" @click="dialogVisible = true">
          <i class="el-icon-edit-outline sed-title"></i>修改
        </el-button>
      </p>
      <p style="clear:both"></p>
    </div>
    <!-- 修改密码弹框 -->
    <el-dialog title="密码修改" :visible.sync="dialogVisible" width="430px" center>
      <form class="forms grid-content">
        <p>
          <span>旧密码</span>
          <input type="password" placeholder="输入新密码" v-model="password" />
        </p>
        <p>
          <span>新密码</span>
          <input type="password" placeholder="输入新密码" v-model="passwordNew" />
        </p>
        <p>
          <span>确认密码</span>
          <input type="password" placeholder="确认密码" v-model="passwordNew2" />
        </p>
      </form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="pdd">取 消</el-button>
        <el-button type="primary" @click="hospitalPwd">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { companyMsg } from "@/request/api";
import { CompanyContact } from "@/request/api";
import { hospitalPwd } from "@/request/api";
import Cookies from "js-cookie";
export default {
  data() {
    return {
      dialogVisible: false, //修改密码弹框状态
      dialogVisible2: false, //修改联系人信息弹框状态
      Msg: "",
      imgurl: this.Common.imgurl,
      cnName: "", //联系人姓名
      mobile: "", //联系人电话
      userId: "13",
      password: "",
      passwordNew: "",
      passwordNew2: "",
      test: null
    };
  },
  methods: {
    //清除密码弹框数据
      pdd(){
        this.dialogVisible = false;
        this.password = '',
        this.passwordNew = '',
        this.passwordNew2 = ''
      },
    // 修改用户信息
      // 去除空格
      removeAllSpace(str) {
        return str.replace(/\s+/g, "");
      },
 

      // 修改用户信息的用户姓名
      checkUserName(){
        if(this.cnName){
          let tempProjectDesc = this.removeAllSpace(this.cnName);
          let myregNum = /^[0-9]+\.{0,1}[0-9]{0,2}$/ ;
          let myregParti = /^[`~!@#$^&*()=|{}':;',\\\[\]\.<>\/?~！@#￥……&*（） ——|{}【】'；：""'。，、《》？\s]+$/ ;
          if(myregNum.test(tempProjectDesc) || myregParti.test(tempProjectDesc)){
            this.$message.error("请勿输入纯数字或者纯特殊字符");
            return false;
          }else{
            return true;
          }
        }else{
          this.$message.error("请输入用户姓名");          
          return false;
        }
      },
      // 修改用户信息的用户手机号
      checkUserContact(){
        if(this.mobile){
          let myreg=/^[1][3,4,5,7,8][0-9]{9}$/;
          if(!myreg.test(this.mobile)){
            this.$message.error("手机号码格式错误，请重新输入");
            return false;
          }else{
            return true;
          }
        }else{
          this.$message.error("请输入联系人手机号码");
          return false;
        }
      },

    submit1() {
      let data = {
        cnName: this.cnName,
        mobile: this.mobile,
        userId: this.userId
      };
      CompanyContact(data)
        .then(res => {
          if (res.data.code == "00000") {
            this.$message({
              message: "修改成功",
              type: "success"
            });
            this.companyMsg();
          } else {
            this.$message.error(res.data.message);
          }

          this.dialogVisible2 = false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 修改密码
    hospitalPwd() {
      if (this.passwordNew != this.passwordNew2) {
        if (this.test) {
          this.test.close();
        }
        this.test = this.$message.error("两次密码不一致");
      } else if (this.password == "") {
        if (this.test) {
          this.test.close();
        }
        this.test = this.$message.error("旧密码不能为空");
      } else {
        let data = {
          password: this.password,
          passwordNew: this.passwordNew,
          userId: this.userId
        };
        hospitalPwd(data)
          .then(res => {
            if (res.data.code == "00000") {
              this.$message({
                message: "修改成功",
                type: "success"
              });
              this.dialogVisible = false;
              this.password = '',
              this.passwordNew = '',
              this.passwordNew2 = ''
            } else {
              this.$message.error(res.data.message);
            }
          })
          .catch(err => {
            console.log(err);
            this.$message({
              message:"修改密码失败，请重新修改！"
            })
          });

      }
    },
    // 获取用户信息
    companyMsg() {
      companyMsg(this.userId)
        .then(res => {
          console.log(res.data.data);
          this.Msg = res.data.data;
          this.cnName = res.data.data.contactName;
          this.mobile = res.data.data.contactMobile;
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    this.userId = Cookies.get("userid");
    this.companyMsg();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.menas {
  margin-top: 20px;
  margin-bottom: 20px;
}
.menas1 {
	height: 180px;
  margin-top: 20px;
  margin-bottom: 20px;
}
.menas li {
  display: inline-block;
  width: 30%;
}

.title {
  font-size: 20px;
  margin-bottom: 30px;
}

.sed-title {
  color: #999999;
  margin-right: 15px;
}

.edit {
  cursor: pointer;
}

.forms p {
  margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/administrators/company-means.vue